import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import './mobile-otp-verification-style.scss';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import useTimer from "@src/hooks/useTimer";
import useMobileOtp from "@src/hooks/useOTPVerification";

import Button from "@src/componentsNew/Buttons/Button";
import Typography from "@src/componentsNew/Typography/Typography";
import MobileCustomHeader from "@src/componentsNew/Header/CustomHeader/MobileCustomHeader";

const MobileOTPVerificationPage = ({ }) => {
  const history = useHistory();

  const [step, setStep] = useState("1");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isShowSnackbar] = useState(true);

  const { time, startTimer } = useTimer(60);
  const { handleRequestOtp, handleVerifyOtp } = useMobileOtp({ setStep, time, startTimer, isShowSnackbar });

  const onBackBtnClick = () => {
    if (step === "1" || step === "3") {
      history.goBack();
    } else if (step === "2") {
      setStep("1");
      setOtp("");
    }
  };

  const handleChangeMobileNumber = (e) => {
    const value = e.target.value;

    // 숫자인지 & 10자리 이하인지 검사
    const isValidInput = /^\d{0,10}$/.test(value);

    if (isValidInput) {
      setMobileNumber(value);
    }
  };

  const handleChangeOtp = (e) => {
    const value = e.target.value;

    // 숫자인지 & 6자리 이하인지 검사
    const isValidInput = /^\d{0,6}$/.test(value);

    if (isValidInput) {
      setOtp(value);
    }
  };

  const handleClickButton = () => {
    if (step === "1") {
      // OTP 번호 요청
      handleRequestOtp(mobileNumber);
    } else if (step === "2") {
      // OTP 유효 체크
      handleVerifyOtp(otp, mobileNumber);
    } else if (step === "3") {
      history.goBack();
    }
  };

  return (
    <div id="mobile-otp-verification-page-container">
      <MobileCustomHeader
        isShowBackBtn={true}
        onBackBtnClick={onBackBtnClick}
      />

      <div className={`text-wrapper ${step === "3" ? "step3" : ""}`}>
        <Typography
          cName="title-text"
          variant="h5"
          component="h5"
          style={{ color: "#000000" }}>
          {
            step === "1" || step === "2" ? "OTP Verification"
              : "Complete!"
          }
        </Typography>

        <div>
          <Typography
            cName="normal-text"
            variant="body3"
            component="p"
            style={{ color: "#11141D99" }}>
            {
              step === "1" ? "We will send you an OTP number on"
                : step === "2" ? "Enter the OTP you received on "
                  : "Now you can receive"
            }
          </Typography>
          <Typography
            cName="normal-text"
            variant="body3"
            component="p"
            style={{ color: "#11141D99" }}>
            {
              step === "1" ? "this mobile number"
                : step === "2" ? `+ 91 ${mobileNumber}`
                  : "all the notifications via message."
            }
          </Typography>
        </div>
      </div>

      {
        step === "1" ?
          <div className="phone-num-input-wrapper">
            <input
              className="phone-num-input"
              type="text"
              placeholder="+ 91 Mobile Number"
              value={mobileNumber}
              onChange={(e) => handleChangeMobileNumber(e)}
            />
          </div> : step === "2" ?
            <>
              <div className="otp-input-wrapper">
                <input
                  className="otp-input"
                  type="text"
                  placeholder="000000"
                  value={otp}
                  onChange={(e) => { handleChangeOtp(e) }}
                />
              </div>

              <Typography
                cName="timer-text"
                variant="subtitle1"
                component="span"
                style={{ color: "#FF3399" }}>
                {String(time.minutes).padStart(2, '0')}:{String(time.seconds).padStart(2, '0')}
              </Typography>

              <Typography
                cName="request-otp-text"
                onClick={() => handleRequestOtp(mobileNumber)}
                variant="body1"
                component="span"
                style={{ color: "#11141D99" }}>
                OTP not received?
              </Typography>
            </>
            : step === "3" ?
              <div className="success-icon-wrapper">
                <CheckCircleOutlineOutlinedIcon className="success-icon" style={{ color: "#4CAF50" }} />
              </div>
              : null
      }

      <Button size="large" cName="step-btn" variant="contained" onClick={handleClickButton}>
        {
          step === "1" ? "Next"
            : step === "2" ? "Verify & Proceed"
              : "Continue"
        }
      </Button>
    </div>
  );
};

export default MobileOTPVerificationPage;
